export default __webpack_public_path__ + "static/media/ddsu5168_2p_rs485_gw152.3975e162.jpg";